import './index.scss'

import { render } from 'react-dom'

import Peoplevine from './apps/peoplevine'
import reportWebVitals from './reportWebVitals'

render(<Peoplevine />, document.querySelector('#root'))
reportWebVitals()
